import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-687a200a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderOutOfStockLog SideBar_False" }
const _hoisted_2 = { class: "OrderOutOfStockLog_Title" }
const _hoisted_3 = { class: "OrderOutOfStockLog_TableContainer" }
const _hoisted_4 = { class: "OrderOutOfStockLog_Table" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("受注管理"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("年度")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("受注管理"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("No")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow1" }, [
      /*#__PURE__*/_createTextVNode("明細"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("No")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Long1" }, "イベント名称"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow1" }, "取次協会コード"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow1" }, "取引先コード"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Middle2" }, "会社名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("書店"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("番線・"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("仕分")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Area" }, "地区名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Long1" }, "書店名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow1" }, "条件区分"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "条件名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("書誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode(" 版元書誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード① ")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Middle2" }, "ISBN13桁"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Title" }, "正式書名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("雑誌"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("コード")
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "本体価格"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "受注数"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "取置No"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, [
      /*#__PURE__*/_createTextVNode("出荷"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("指示数")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      class: "OrderOutOfStockLog_Table_Narrow1",
      style: {"z-index":"100"}
    }, " 削除 "),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "正味"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Middle2" }, "短冊備考2"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "登録日"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Middle1" }, "氏名"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Middle2" }, "作業備考"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Middle1" }, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "OrderOutOfStockLog_Table_Narrow2" }, "出荷可能在庫")
  ])
], -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "Text_Left" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "Text_Left" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "Text_Left" }
const _hoisted_17 = { class: "Text_Left" }
const _hoisted_18 = { class: "" }
const _hoisted_19 = { class: "" }
const _hoisted_20 = { class: "" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "Text_Left" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "" }
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "" }
const _hoisted_30 = ["checked"]
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "Text_Left" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "" }
const _hoisted_36 = { class: "Text_Left" }
const _hoisted_37 = { class: "" }
const _hoisted_38 = {
  key: 0,
  class: "ResultMessageNull"
}

import axios from "axios";
import { Notyf } from "notyf";
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ShowShinagireList } from "./OrderOutOfStock.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderOutOfStockLog',
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const route = useRoute();
const notyf = new Notyf();
const emit = __emit;

emit("toggleGlobalHeader");

// データ取得
const search_result = ref([] as ShowShinagireList[]);
const getData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/orderOutOfStock/display-from-dashborad?uuid=${route.query.uuid}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    search_result.value = res.data.mstShinagire;
  } catch (error) {
    console.log(error);
    notyf.error("データの取得に失敗しました");
  }
};
getData();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " 品切保留 変更履歴（" + _toDisplayString(_unref(route).query.updateTime) + " " + _toDisplayString(_unref(route).query.times) + "回目） ", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        (search_result.value.length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (result, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: _normalizeClass({
              'bg-orange': result.availableAmount >= result.juchuSuu,
              'bg-red':
                result.availableAmount < result.juchuSuu &&
                Number(result.inputSyukkoSuu) > 0,
            })
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(result.shinagireYear), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(result.shinagireNumber), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(result.meisaiId), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(result.eventMei), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(result.toritugiCd), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(result.torihikisakiCd), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(result.companyName), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(result.syotenCd), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(result.bansen), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(result.chikuMei), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(result.syotenMei), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(result.joukenKbn), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(result.joukenMei), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(result.syosiCd), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(result.hanmotoSyosiCd1), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(result.isbn), 1),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(result.seisikiSyomei), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(result.zassiCd), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(result.hontaiPrice), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(result.juchuSuu), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(result.toriokiNumber), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(result.syukkoSuu), 1),
                  _createElementVNode("td", _hoisted_29, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: Number(result.deleteKbn) === 9,
                      disabled: ""
                    }, null, 8, _hoisted_30)
                  ]),
                  _createElementVNode("td", _hoisted_31, _toDisplayString(result.syoumi), 1),
                  _createElementVNode("td", _hoisted_32, _toDisplayString(result.tanzakuRemarks2), 1),
                  _createElementVNode("td", _hoisted_33, _toDisplayString(result.tourokuDate), 1),
                  _createElementVNode("td", _hoisted_34, _toDisplayString(result.name), 1),
                  _createElementVNode("td", _hoisted_35, _toDisplayString(result.companyRemarks), 1),
                  _createElementVNode("td", _hoisted_36, _toDisplayString(result.category), 1),
                  _createElementVNode("td", _hoisted_37, _toDisplayString(result.availableAmount), 1)
                ], 2))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!search_result.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_38, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})